import requireAuth from "../context/requireAuth";
import { useState, useEffect, useMemo } from "react";
import axios from "../context/axiosConfig";
import { MaterialReactTable } from "material-react-table";
import { Skeleton } from "@mui/material";

const canvasWidth = 300;
const canvasProps = { width: canvasWidth, height: canvasWidth * (3 / 5) };

function Signatures() {
  const [signatures, setSignatures] = useState([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 100,
  });

  const org_id = localStorage.getItem("organization");

  /* fetch data */
  useEffect(() => {
    const fetchData = async () => {
      if (!signatures.length) {
        setIsLoading(true);
      } else {
        setIsRefetching(true);
      }

      try {
        const response = await axios.get(
          `orgs/${org_id}/signatures/`,
          { 
            withCredentials: true,
            params: {
              page: pagination.pageIndex + 1,
              page_size: pagination.pageSize,
            }
          }
        );
        setSignatures(response.data.items);
        setRowCount(response.data.total_items);
      } catch (error) {
        setIsError(true);
        console.error(error);
        return;
      }
      setIsError(false);
      setIsLoading(false);
      setIsRefetching(false);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.pageIndex, pagination.pageSize]);

  /* column definitions */
  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "ID",
        size: 80,
      },
      {
        accessorKey: "deletion_type",
        header: "Deletion Type",
        size: 200,
      },
      {
        accessorKey: "entity_no",
        header: "Deleted Object UID",
        size: 200,
      },
      {
        accessorKey: "signature1",
        header: "Signature 1",
        size: canvasProps.width,
        Cell: ({ cell }) => (
          <img
            src={cell.getValue()}
            alt="signature 1"
            width={canvasProps.width}
            height={canvasProps.height}
            loading="lazy"
            decoding="async"
            style={{ objectFit: "contain" }}
          />
        ),
        enableSorting: false,
      },
      {
        accessorKey: "signature2",
        header: "Signature 2",
        size: canvasProps.width,
        Cell: ({ cell }) => (
          <img
            src={cell.getValue()}
            alt="signature 2"
            width={canvasProps.width}
            height={canvasProps.height}
            loading="lazy"
            decoding="async"
            style={{ objectFit: "contain" }}
          />
        ),
        enableSorting: false,
      },
    ],
    []
  );

  return (
    <div className="bodyContent">
      <div className="plantTableDiv" style={{ marginTop: 40 }}>
        <MaterialReactTable
          columns={columns}
          data={signatures}
          initialState={{ showColumnFilters: true }}
          manualPagination
          muiToolbarAlertBannerProps={
            isError
              ? { color: 'error', children: 'Error loading data' }
              : undefined
          }
          onPaginationChange={setPagination}
          rowCount={rowCount}
          state={{
            isLoading,
            pagination,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
          }}
          enableRowActions={false}
          displayColumnDefOptions={{
            "mrt-row-select": { size: 0, hidden: true },
          }}
          muiTableBodyProps={{ sx: { "& tr": { height: canvasProps.height + 24 } } }}
        />
      </div>
    </div>
  );
}

export default requireAuth(Signatures);
